export const maskString = (input: string) => {
  if (input.length <= 6) {
    return input;
  }
  const start = input.slice(0, 3);
  const end = input.slice(-3);
  return `${start}****${end}`;
};
